import { useState, useEffect, useCallback } from "react";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
export const VALIDATION_MESSAGES = {
    LENGTH: "Alias must be 3 to 19 characters.",
    ALPHANUMERIC: "Alias must only contain alphanumeric characters (a-z, 0-9).",
    AVAILABILITY_ERROR: "Checking alias availability was not successful. Please try again.",
    ALREADY_TAKEN: "Alias is already claimed.",
};
export const useAliasValidation = (alias, adapter) => {
    const [validation, setValidation] = useState({
        length: { isValid: true, message: "" },
        alphanumeric: { isValid: true, message: "" },
        availability: { isValid: true, message: "" },
        isValid: false,
        claimFail: { isValid: true, message: "" },
    });
    const [isChecking, setIsChecking] = useState(false);
    const { t } = useLocalizedString();
    useEffect(() => {
        if (alias) {
            const lengthValid = alias.length >= 3 && alias.length <= 19;
            const alphanumericValid = /^[a-z0-9]{3,19}$/.test(alias);
            setValidation((prev) => ({
                ...prev,
                length: {
                    isValid: lengthValid,
                    message: lengthValid ? "" : t(VALIDATION_MESSAGES.LENGTH),
                },
                alphanumeric: {
                    isValid: alphanumericValid,
                    message: alphanumericValid ? "" : t(VALIDATION_MESSAGES.ALPHANUMERIC),
                },
                isValid: lengthValid && alphanumericValid && prev.availability.isValid,
            }));
        }
        else {
            setValidation((prev) => ({
                ...prev,
                length: { isValid: true, message: "" },
                alphanumeric: { isValid: true, message: "" },
                isValid: false,
            }));
        }
    }, [alias]);
    const checkAvailability = useCallback(async (value) => {
        if (value &&
            validation.length.isValid &&
            validation.alphanumeric.isValid) {
            setIsChecking(true);
            try {
                const response = await adapter.CheckAlias(value.toLowerCase());
                const availabilityValid = response.isAliasAvailable;
                const availabilityMessage = !response.isAliasAvailable
                    ? t(VALIDATION_MESSAGES.ALREADY_TAKEN)
                    : "";
                setValidation((prev) => ({
                    ...prev,
                    availability: {
                        isValid: availabilityValid,
                        message: availabilityMessage,
                    },
                    isValid: availabilityValid &&
                        prev.length.isValid &&
                        prev.alphanumeric.isValid,
                }));
            }
            catch (error) {
                setValidation((prev) => ({
                    ...prev,
                    availability: {
                        isValid: false,
                        message: t(VALIDATION_MESSAGES.AVAILABILITY_ERROR),
                    },
                    isValid: false,
                }));
            }
            finally {
                setIsChecking(false);
            }
        }
    }, [validation.length.isValid, validation.alphanumeric.isValid]);
    return { validation, isChecking, checkAvailability };
};
//# sourceMappingURL=useAliasValidation.js.map